// RAC Parks & Resorts booking strategy.
//
// Newbook white-label embedded in WordPress at parksandresorts.rac.com.au.
// The booking page accepts the category via `force_category_id` (already
// encoded in `site.reserveUrl`) and optionally prefills the date window via
// unix-second timestamps:
//
//   available_from=<unix-seconds>
//   available_to=<unix-seconds>
//   adults=<N>
//
// All three are no-ops if absent — the page falls back to the bare
// category-selector view (which is what defaultStrategy previously
// produced). Discovery probe confirmed both shapes return 200 + a usable
// booking page (see agencies/RACParksResorts/proof/discovery.md).

import { resolveCheckout, resolveMinCapacity } from "./_context.js";

function unixSeconds(date) {
  return Math.floor(date.getTime() / 1000);
}

export default {
  buildBookingUrl(ctx) {
    const { site, arrivalDate } = ctx;
    const checkout = resolveCheckout(ctx);
    const adults = resolveMinCapacity(ctx);

    const url = new URL(site.reserveUrl);
    url.searchParams.set("available_from", String(unixSeconds(arrivalDate)));
    url.searchParams.set("available_to", String(unixSeconds(checkout)));
    url.searchParams.set("adults", String(adults));
    return url.toString();
  },

  buildPreviewUrl(site) {
    const url = new URL(site.reserveUrl);
    url.search = "";
    return url.toString();
  },

  describeBookingInputs() {
    return {
      inputs: {
        arrivalDate: {
          status: "required",
          notes: "Encoded as &available_from=<unix-seconds>.",
        },
        departureDate: {
          status: "required",
          notes:
            "Encoded as &available_to=<unix-seconds>; resolved from arrival + minStayLength when not supplied.",
        },
        ref: {
          status: "ignored",
          notes:
            "site.reserveUrl already encodes force_category_id; ref itself is not propagated.",
        },
        partySize: {
          status: "encoded",
          defaultValue: 1,
          notes:
            "Encoded as &adults=<N>; defaults to AvailabilityRequest.minCapacity, then 1.",
        },
      },
    };
  },
};
